export const availableIds = [
    'gin:908bd706-afb8-44aa-bad4-bd9b6375a671',
    'gin:66e4c786-dbe1-4410-b817-ca52cd9d2e35',
] as const;
